import { api } from './api'
import {
  PracticeVaccine,
  PracticeVaccineListResponse,
  PracticeVaccineFormData,
} from '../types/practiceVaccine'

export const practiceVaccineService = {
  /**
   * Get all practice vaccines
   */
  getPracticeVaccines: async (): Promise<PracticeVaccineListResponse> => {
    const response = await api.get<PracticeVaccineListResponse>('/practice-vaccines')
    return response.data
  },

  /**
   * Get expired vaccines
   */
  getExpiredVaccines: async (): Promise<PracticeVaccineListResponse> => {
    const response = await api.get<PracticeVaccineListResponse>('/practice-vaccines/expired')
    return response.data
  },

  /**
   * Get vaccines by type
   */
  getVaccinesByType: async (vaccineType: string): Promise<PracticeVaccineListResponse> => {
    const response = await api.get<PracticeVaccineListResponse>(
      `/practice-vaccines/type/${encodeURIComponent(vaccineType)}`,
    )
    return response.data
  },

  /**
   * Get a specific practice vaccine
   */
  getPracticeVaccine: async (vaccineId: string): Promise<PracticeVaccine> => {
    const response = await api.get<PracticeVaccine>(`/practice-vaccines/${encodeURIComponent(vaccineId)}`)
    return response.data
  },

  /**
   * Create/add vaccine stock
   */
  createPracticeVaccine: async (payload: PracticeVaccineFormData): Promise<PracticeVaccine> => {
    const response = await api.post<PracticeVaccine>('/practice-vaccines', payload)
    return response.data
  },

  /**
   * Update vaccine stock
   */
  updatePracticeVaccine: async (
    vaccineId: string,
    payload: Partial<PracticeVaccineFormData & { isActive?: boolean; quantity?: number }>,
  ): Promise<PracticeVaccine> => {
    const response = await api.put<PracticeVaccine>(
      `/practice-vaccines/${encodeURIComponent(vaccineId)}`,
      payload,
    )
    return response.data
  },

  /**
   * Delete/inactivate a practice vaccine
   */
  deletePracticeVaccine: async (vaccineId: string): Promise<void> => {
    await api.delete(`/practice-vaccines/${encodeURIComponent(vaccineId)}`)
  },
}
